import React from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";

type Option = {
  value: string;
  label: string;
};

interface FormSelectProps {
  name: string;
  label?: string;
  options: Option[];
  register: UseFormRegister<any>;
  errors: FieldErrors;
  isFocused: boolean;
  onFocus: () => void;
  onBlur: () => void;
}

const FormSelect: React.FC<FormSelectProps> = ({
  name,
  label,
  options,
  register,
  errors,
  isFocused,
  onFocus,
  onBlur,
}) => {
  return (
    <div className="mb-3" style={{ position: "relative" }}>
      {label && (
        <label htmlFor={name} className="form-label contact-text">
          {label}
        </label>
      )}

      <div style={{ position: "relative" }}>
        <select
          id={name}
          {...register(name)}
          onFocus={onFocus}
          onBlur={onBlur}
          style={{
            width: "100%",
            padding: "6px 12px",
            paddingRight: "40px", // 👈 space for the arrow
            border: errors[name]
              ? "1px solid #dc3545" // error border
              : isFocused
                ? "1px solid #86b7fe" // focused border
                : "1px solid #ccc", // normal border
            boxShadow:
              isFocused && !errors[name]
                ? "0 0 0 .25rem rgba(13, 110, 253, .25)"
                : "",
            borderRadius: "4px",
            outline: "none",
            appearance: "none",
            WebkitAppearance: "none",
            MozAppearance: "none",
          }}
        >
          <option value="">Select an option</option>
          {options.map(opt => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        {/* Custom dropdown arrow */}
        <span
          style={{
            position: "absolute",
            top: "50%",
            right: "12px",
            transform: "translateY(-50%)",
            pointerEvents: "none",
            fontSize: "16px",
            color: "#333",
          }}
        >
          ▼
        </span>
      </div>

      {errors[name] && (
        <div className="text-danger mt-1">
          {errors[name]?.message as string}
        </div>
      )}
    </div>
  );
};

export default FormSelect;
